import React from 'react'
import { List, ListItem } from 'material-ui/List'
import Chached from 'material-ui/svg-icons/action/cached'
import LiveHelp from 'material-ui/svg-icons/communication/live-help'
import VerifiedUser from 'material-ui/svg-icons/action/verified-user'
import LocalShipping from 'material-ui/svg-icons/maps/local-shipping'
import Book from 'material-ui/svg-icons/action/book'
import Divider from 'material-ui/Divider'
import FiberManualRecord from 'material-ui/svg-icons/av/fiber-manual-record'
import Paper from 'material-ui/Paper'
import { HashLink as Link } from 'react-router-hash-link'

const styles = {
  paper: {
    display: 'inline-block',
  },
}

const InfoSideMenu = () => (
  <Paper style={styles.paper}>
    <List>
      <ListItem
        containerElement={<Link to="/come-funziona#perche-swapick" />}
        primaryText="Perchè Swapick"
        leftIcon={<Chached />}
      />
      <ListItem
        containerElement={<Link to="/come-funziona#come-fare" />}
        primaryText="Come funziona"
        leftIcon={<Book />}
      />
      <ListItem
        containerElement={<Link to="/come-funziona#guida-sicurezza" />}
        primaryText="Guida alla sicurezza"
        leftIcon={<VerifiedUser />}
      />
      <ListItem
        containerElement={<Link to="/come-funziona#spedizione-oggetti" />}
        primaryText="Spedizione degli oggetti"
        leftIcon={<LocalShipping />}
      />
      <ListItem
        containerElement={<Link to="/come-funziona#faq" />}
        primaryText="Domande frequenti"
        leftIcon={<LiveHelp />}
      />
    </List>
    <Divider />
    <List>
      <ListItem
        containerElement={<Link to="/come-funziona#servizi-aggiuntivi" />}
        primaryText="Servizi Aggiuntivi"
        rightIcon={<FiberManualRecord />}
      />
      <ListItem
        containerElement={<Link to="/come-funziona#termini-condizioni" />}
        primaryText="Termini e condizioni"
        rightIcon={<FiberManualRecord />}
      />
      <ListItem
        containerElement={<Link to="/come-funziona#privacy-policy" />}
        primaryText="Privacy Policy"
        rightIcon={<FiberManualRecord />}
      />
      <ListItem
        containerElement={<Link to="/come-funziona#cookie-policy" />}
        primaryText="Cookie Policy"
        rightIcon={<FiberManualRecord />}
      />
    </List>
  </Paper>
)

export default InfoSideMenu



// WEBPACK FOOTER //
// ./src/common/InfoSideMenu.js